import React, { ReactElement, useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import YouTube from "react-youtube";

import apiRequest from "../../../apis/request";

// Styles
import "../videoStream.scss";

const Youtube = (props): ReactElement => {
  const { settings, type } = props;
  const [isActive, setIsActive] = useState(false);
  const [isPaused, setIsPaused] = useState(true);
  const time = useRef(0);
  const interval = useRef<any>();

  const { track } = useSelector(({ track }) => ({
    track: track,
  }));

  useEffect(() => {
    return () => {
      time.current = 0;
      clearInterval(interval.current);
    };
  }, [settings?.videoId]);

  useEffect(() => {
    let _interval = null;

    if (isActive && isPaused === false) {
      _interval = setInterval(() => {
        time.current = time.current + 10;
      }, 10);
    } else {
      clearInterval(_interval);
    }
    return () => {
      clearInterval(_interval);
    };
  }, [isActive, isPaused]);

  const handleStart = () => {
    setIsActive(true);
    setIsPaused(false);
  };

  const handlePauseResume = () => {
    setIsPaused(!isPaused);
  };

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
      }}>
      {settings?.videoId && type === "youtube" && (
        <YouTube
          videoId={settings?.videoId}
          containerClassName="ytContainer"
          opts={{
            height: "100%",
            width: "100%",

            playerVars: {
              autoplay: settings?.autoPlay ? 1 : 0,
              rel: 0,
              showinfo: 1,
              modestbranding: 2,
            },
          }}
          onPlay={() => {
            if (props.sessionId) {
              interval.current = setInterval(() => {
                apiRequest("POST", "/a/replay", [], {
                  trackId: track.docId,
                  sessionId: props.sessionId,
                  watchDuration: parseFloat(time.current / 1000),
                });
              }, 2000);
            }
            handleStart();
          }}
          onPause={() => {
            clearInterval(interval.current);
            handlePauseResume();
          }}
        />
      )}
    </div>
  );
};

export default Youtube;
